export default __webpack_public_path__ + "6a283272c2b996622003069b56347a62.svg";